import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatErr } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);

  async function submit(e) {
    e.preventDefault();
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) { toast.error(formatErr(err.response?.data?.detail) || "Failed"); }
  }

  return (
    <div className="min-h-screen grid place-items-center p-6 grain">
      <Card className="w-full max-w-md bg-[hsl(224_45%_9%)] border-border p-8 relative z-10">
        <h2 className="font-display text-3xl font-bold mb-1">Forgot password</h2>
        <p className="text-sm text-muted-foreground mb-6">Enter your email and we'll send you a reset link.</p>
        {sent ? (
          <div className="p-4 rounded-md border border-emerald-500/40 bg-emerald-500/10 text-sm text-emerald-200">
            If an account matches <span className="font-mono">{email}</span>, a reset link has been generated.
            Check the admin console log (or contact your fleet admin) to retrieve the token.
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div><Label className="text-xs uppercase tracking-wider text-muted-foreground">Email</Label>
              <Input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="fp-email" className="mt-1.5 h-11 bg-[hsl(224_40%_12%)]"/></div>
            <Button data-testid="fp-submit" className="w-full h-11 bg-amber-500 text-[hsl(224_60%_6%)] hover:bg-amber-400 font-semibold">Send reset link</Button>
          </form>
        )}
        <div className="mt-5 text-xs text-center text-muted-foreground">
          <Link to="/login" className="text-amber-400 hover:underline">Back to sign in</Link>
          <span className="mx-2">·</span>
          <Link to="/reset-password" className="text-amber-400 hover:underline">Have a token?</Link>
        </div>
      </Card>
    </div>
  );
}
